interface IKVMap<T> {
    [k: string]: T
}

export type ITranslations = IKVMap<string|ITranslations>
export type ICountry = IKVMap<string|number>

export interface IState {
    translations: ITranslations
    countries: Array<ICountry>
}

export const initialState: IState = {
    translations: {},
    countries: []
};
